/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="111.92" height="65.05" viewBox="0 0 111.92 65.05" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <defs>
    <mask id="f8d5d6e6-b6b5-4e2b-93ac-6e4f754b5dc4" x="7.57" y="0" width="96.62" height="54.66" maskUnits="userSpaceOnUse">
      <g transform="translate(-22 -45)">
        <polygon points="29.57 45 126.19 45 126.19 99.66 29.57 99.66 29.57 45" fill="#fff" fillRule="evenodd"/>
      </g>
    </mask>
    <mask id="a6f0d614-f504-431a-8725-70ea95936f6c" x="0" y="53.07" width="111.92" height="11.98" maskUnits="userSpaceOnUse">
      <g transform="translate(-22 -45)">
        <polygon points="22 98.07 133.92 98.07 133.92 110.05 22 110.05 22 98.07" fill="#fff" fillRule="evenodd"/>
      </g>
    </mask>
  </defs>
  <g>
      <g>
        <g mask="url(#f8d5d6e6-b6b5-4e2b-93ac-6e4f754b5dc4)">
          <path d="M124.94,99.66a1.25,1.25,0,0,1-1.25-1.25V50.21a2.84,2.84,0,0,0-2.94-2.71H35a2.84,2.84,0,0,0-2.94,2.71v48.2a1.25,1.25,0,0,1-2.5,0V50.21A5.34,5.34,0,0,1,35,45h85.74a5.34,5.34,0,0,1,5.44,5.21v48.2a1.25,1.25,0,0,1-1.25,1.25" transform="translate(-22 -45)" fill="#094b7b" fillRule="evenodd"/>
        </g>
      </g>
      <g>
        <g mask="url(#a6f0d614-f504-431a-8725-70ea95936f6c)">
          <path d="M31.32,108H124.7a6,6,0,0,0,4.56-1.58c1.89-1.82,2.44-4.75,2.6-6.27-10.52,0-97.27-.11-107.79-.12.25,2.35,1.47,8,7.25,8Zm93.7,2H31.31C24,110,22,102.87,22,99.08c0-1,.93-1,1.61-1h1.75l59.77.05,43.83.06c5,0,5,0,5,1,0,.23,0,5.59-3.27,8.71a7.8,7.8,0,0,1-5.63,2.15Z" transform="translate(-22 -45)" fill="#094b7b" fillRule="evenodd"/>
        </g>
      </g>
      <path d="M38.39,98.36h79.14v-45H38.39ZM118,99.86H37.92a1,1,0,0,1-1-1V52.94a1,1,0,0,1,1-1H118a1,1,0,0,1,1,1V98.82a1,1,0,0,1-1,1Z" transform="translate(-22 -45)" fill="#094b7b" fillRule="evenodd"/>
      <polygon points="46.64 19.21 72.9 23.46 59.56 42.63 46.64 19.21" fill="#fcb61b" fillRule="evenodd"/>
      <polygon points="80.57 39.2 76.62 44.73 62.19 34.42 66.15 28.89 80.57 39.2" fill="#fcb61b" fillRule="evenodd"/>
    </g>
</svg>

    );
  }
}

Icon.displayName = 'ComputerScreenWithMouseArrowIcon';

export default Icon;
